/* Copyright (c) 2023 Xperi. All Rights Reserved. */

import {
    Error400CodeEnum,
    Error404CodeEnum,
    Error405CodeEnum,
    Error500CodeEnum,
    ErrorDefaultCodeEnum,
} from 'client-code/branding-ui-bundle';
import { ErrorTypes } from './ErrorTypes';
import { PostSignInError } from './PostSignInError';

export class BrandingUiBundleError extends PostSignInError {
    TAG: string = 'BrandingUiBundleError';

    constructor(message: string, code: string) {
        super(message, code);
        this.setCode(code);
    }

    private setCode(code: string): void {
        switch (code) {
            case ErrorDefaultCodeEnum.ApigwError:
                this.code = ErrorTypes.BRANDING_APIGW_ERROR_C1401;
                this.type = ErrorDefaultCodeEnum.ApigwError;
                break;
            case Error400CodeEnum.BadRequest:
                this.code = ErrorTypes.BRANDING_BAD_REQUEST_C1402;
                this.type = Error400CodeEnum.BadRequest;
                break;
            case Error404CodeEnum.ResourceNotFound:
                this.code = ErrorTypes.BRANDING_RESOURCE_NOT_FOUND_C1405;
                this.type = Error404CodeEnum.ResourceNotFound;
                break;
            case Error405CodeEnum.MethodNotAllowed:
                this.code = ErrorTypes.BRANDING_METHOD_NOT_ALLOWED_C1404;
                this.type = Error405CodeEnum.MethodNotAllowed;
                break;
            case Error500CodeEnum.InternalServerError:
                this.code = ErrorTypes.BRANDING_INTERNAL_SERVER_ERROR_C1403;
                this.type = Error500CodeEnum.InternalServerError;
                break;
            default:
                this.code = ErrorTypes.BRANDING_UNKNOWN_ERROR_C1499;
                this.type = 'BRANDING_UNKNOWN_ERROR';
        }
    }
}
